// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"ff453869","651":"d4eddae4"}[chunkId] + ".chunk.js";
};